import { combineReducers } from 'redux'
// import { createReduxEnhancer as sentryReduxEnhancer } from '../sentry'
import userReducer from './userReducer'

export const rootReducer = combineReducers({
  userReducer: userReducer,
})

export type AppState = ReturnType<typeof rootReducer>
